<template>
    <!-- <div class="modal">
        <div class="modal__container">
			<div class="header">
				<i class="ico-ct-4"></i>
				<h3>Detalhes</h3>
				<button class="close" @click="$emit('close', alterado)">
					<img src="/static/assets/images/ico-close.svg" alt="Icone fechar">
				</button>
			</div>
			<hr /> -->



	<div class="content">
		<!-- PAGAMENTO -->
		<ComponentePagamento v-if="operacao.Tipo === 'PAGAMENTO'" :operacao="operacao" />

		<!-- TRANSFERENCIA -->
		<ComponenteTransferencia v-if="operacao.Tipo === 'TRANSFERENCIA'" :operacao="operacao" />

		<!-- INVESTIMENTO -->
		<ComponenteDeposito v-if="operacao.Tipo === 'DEPOSITO'" :operacao="operacao" />

		<!-- EXTORNO -->
		<ComponenteExtorno v-if="operacao.Tipo === 'EXTORNO' || operacao.Tipo === 'ESTORNO'" :operacao="operacao" />

		<!-- DEPOSITO -->
		<ComponenteInvestimento v-if="operacao.Tipo === 'INVESTIMENTO'" :operacao="operacao" />
		
	</div>



        <!-- </div>
    </div> -->
</template>

<script>

	import ComponentePagamento from './Operacoes/Pagamento'
	import ComponenteTransferencia from './Operacoes/Transferencia'
	import ComponenteDeposito from './Operacoes/Deposito'
	import ComponenteExtorno from './Operacoes/Extorno'
	import ComponenteInvestimento from './Operacoes/Investimento'

	export default {

		components: {
			ComponentePagamento,
			ComponenteTransferencia,
			ComponenteDeposito,
			ComponenteExtorno,
			ComponenteInvestimento
		},

		props: {
			operacao: {type: Object}
		},

		data() {
			return {
				alterado:false,
			}
		}
	}
</script>

<style lang="scss" scoped>

	@import "../../assets/styles/iouu/variables";
	@import "../../assets/styles/iouu/mixins";

	.modal {
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 999999999!important;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .80);
		transition: opacity .3s ease;
		overflow-x: hidden;
		overflow-y: auto;
		font-family: "Helvetica-Neue";

		@include xs {
			align-items: flex-start;
			background-color: #fff;
			height: 100%;
		}

		&__container {
			position: relative;
			width: 640px;
			margin: 0px auto;
			background-color: #fff;
			border-radius: 5px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
			transition: all .3s ease;
			font-family: Helvetica, Arial, sans-serif;
			display: flex;
			flex-direction: column;
			@include xs {
				flex-direction: column;
				left:0px;
				top:0px;
				right: 0px;
				bottom: 0px;
				width: 100%;
				margin: 0px;
				border-radius: 0px;
				box-shadow: none;
			}

			hr {
				margin: 0;
				border: .5px solid #000;
			}

			.header {
				&{
					width: 100%;
					text-align: center;
					padding: 2rem;
					@include gradient-linear(#41D3BD, #0F8B8D);
					border-radius: 5px 5px 0 0;
					position: relative;

					.close {
						position: absolute;
						top: 10px;
						right: 10px;
						color: #fff;
					}

					@include xs {
						border-radius: 0;
					}
				}

				h3 {
					text-transform: uppercase;
					color: #000;
					font-size: 20px;

					@include xs {
						font-size: 18px;
					}
				}

				i {
					font-size: 50px;
					
					@include xs {
						font-size: 30px;
					}
				}
			}

			.content {
				&{
					width: 100%;
					background-color: #fff;
					text-align: center;
					padding: 2rem 0;
					border-radius: 5px;
				}

				@include xs {
					padding: 1rem 0;
				}
			}
		}
	}

	.btn{
		&__exit {
			position: absolute;
			top: 12px;
			right: 12px;
			
			& > svg {
				width: 12px;
			}

			.cls-1 {
				fill: none;
				stroke: #41D3BD;
				stroke-linecap: round;
				stroke-linejoin: round;
				stroke-miterlimit: 10;
				stroke-width: 1.4px;
			}
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/Wallet/WalletDetalhes.vue